import { render, staticRenderFns } from "./Listrefer.vue?vue&type=template&id=5748c236&"
import script from "./Listrefer.vue?vue&type=script&lang=js&"
export * from "./Listrefer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports